/* sugar:assets/collection-load-more.js@2.1.7 */
/*
 * Load more — appends the next page of a card grid (Featured Collection, Blog List) in place.
 *
 * The section renders a "Load more" control under the grid instead of page numbers. A click
 * fetches the next page's URL (which already carries the shopper's filters and sort) through
 * the Section Rendering API, moves its cards into the current grid and swaps the control for
 * the next one. In "scroll" mode the control is a spinner that clicks itself a screen before it
 * comes into view, so the next page is usually in place before the shopper reaches it. Delegated
 * from the document, so a grid replaced by the filter refetch needs no re-init.
 *
 * The grid is found through the shared [data-card-grid] wrapper and its data-item-class, so
 * any section built on card-grid.js can use it; the Featured Collection class names remain
 * as the fallback for markup without that wrapper.
 */
(function () {
  'use strict';

  if (window.SugarLoadMore) return;

  function sectionOf(el) {
    return el.closest('.shopify-section');
  }

  function sectionId(section) {
    return section && section.id ? section.id.replace('shopify-section-', '') : '';
  }

  function gridOf(root) {
    return root.querySelector('[data-card-grid]');
  }

  function itemClassOf(root) {
    var grid = gridOf(root);
    return (grid && grid.getAttribute('data-item-class')) || 'sugar-featured-collection__item';
  }

  /* The element the cards are direct children of: the Splide list when the grid can be a
     slider, otherwise the parent of the first card. */
  function listOf(root, itemClass) {
    var grid = gridOf(root);
    if (grid) {
      var splideList = grid.querySelector('.splide__list');
      if (splideList) return splideList;
      var firstItem = grid.querySelector('.' + itemClass);
      if (firstItem) return firstItem.parentElement;
    }
    return root.querySelector('.sugar-featured-collection__items .splide__list') || root.querySelector('.sugar-featured-collection__items');
  }

  function load(button) {
    if (button._busy) return;
    var section = sectionOf(button);
    var control = button.closest('[data-load-more]');
    var itemClass = section && itemClassOf(section);
    var list = section && listOf(section, itemClass);
    var url = button.getAttribute('data-url');
    if (!section || !control || !list || !url) return;

    button._busy = true;
    button.classList.add('is-loading');

    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId(section));

    fetch(fetchUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshList = listOf(doc, itemClass);
        var items = freshList ? freshList.querySelectorAll('.' + itemClass) : [];
        Array.prototype.forEach.call(items, function (item) {
          list.appendChild(item);
        });
        var freshControl = doc.querySelector('[data-load-more]');
        if (freshControl) {
          control.replaceWith(freshControl);
          arm(section);
        } else {
          control.remove();
        }
        if (window.SugarCardGrid) window.SugarCardGrid.init(section);
        document.dispatchEvent(new CustomEvent('sugar:collection:appended', { detail: { root: section }, bubbles: true }));
      })
      .catch(function () {
        button._busy = false;
        button.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-load-more-button]');
    if (!button) return;
    event.preventDefault();
    load(button);
  });

  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var button = entry.target.querySelector('[data-load-more-button]');
          if (button) load(button);
        });
      }, { rootMargin: '0px 0px 100% 0px' })
    : null;

  function arm(scope) {
    if (!observer) return;
    var host = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(host.querySelectorAll('[data-load-more][data-mode="scroll"]'), function (control) {
      if (control._armed) return;
      control._armed = true;
      observer.observe(control);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { arm(document); });
  } else {
    arm(document);
  }
  document.addEventListener('sugar:collection:rendered', function (event) {
    arm(event.detail && event.detail.root);
  });
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) { arm(event.target); });
  }

  window.SugarLoadMore = { arm: arm };
})();
